import { track } from "jiffy-analytics";
import { on as onEvent } from "common/utils/ui/event";

const trackBrandLinkClick = (_e, brandLinkElm) => {
  track("brand_button_clicked", {
    brand_name: brandLinkElm.dataset.brandLabel,
    position: brandLinkElm.dataset.position
  });
};

export default function initBrandsLinkTracking() {
  onEvent("click", ".js-brand-link-holder > .js-brand-link", trackBrandLinkClick);
}
